export const RISK_BAND_COLORS = {
    'Baixo': '#84cc16',
    'Moderado': '#facc15',
    'Alto': '#f59e0b',
    'Crítico': '#ef4444'
};

export function classifyRiskBand(item) {
    const probabilityWeight = {
        low: 1,
        medium: 2,
        high: 3,
        very_high: 4
    };
    const impactWeight = {
        low: 1,
        medium: 2,
        high: 3,
        very_high: 4
    };

    const total = (probabilityWeight[item?.probability] || 0) + (impactWeight[item?.impact] || 0);
    if (total >= 7) return 'Crítico';
    if (total >= 5) return 'Alto';
    if (total >= 3) return 'Moderado';
    return 'Baixo';
}

export function riskColor(item) {
    return RISK_BAND_COLORS[classifyRiskBand(item)];
}
